module.exports = __webpack_public_path__ + "static/media/youtube.e012e97f.png";